export const C = {
  bg:           '#F5F0E8',
  bgAlt:        '#EDE8DE',
  surface:      '#FFFFFF',
  dark:         '#111D14',
  primary:      '#2D4A3A',
  primaryLight: '#D9E8E0',
  accent:       '#C4614C',
  text:         '#1A2B1E',
  textMuted:    '#6B7566',
  border:       '#DDD8CC',
};
export const F = {
  display: "'Cormorant Garamond', Georgia, serif",
  body:    "'Inter', system-ui, sans-serif",
};
export const S = {
  sm: '0 1px 4px rgba(0,0,0,.07)',
  md: '0 4px 16px rgba(0,0,0,.10)',
  lg: '0 8px 32px rgba(0,0,0,.13)',
};
export const R   = { base: '12px', lg: '20px' };
export const maxW = '1160px';
export const trans = '0.25s ease';
